import { useState, useEffect } from 'react';
import apiClient from '../api/client';

const POLL_INTERVAL = 30000; // Match backend model-status cache TTL

export function useModelStatus() {
  const [modelStatus, setModelStatus] = useState({
    modelAvailable: true, // Optimistically assume available
    cloudFallback: false, // Whether cloud fallback is active
    source: null,         // "local", "cloud", or null
    loading: true,
  });

  const checkModelStatus = async () => {
    try {
      const response = await apiClient.get('/api/model-status');
      const data = response.data;
      const modelAvailable = data.model_available || false;
      const cloudFallback = data.cloud_fallback || false;
      const source = data.source || null;

      setModelStatus({
        modelAvailable,
        cloudFallback,
        source,
        loading: false,
      });
    } catch (error) {
      console.error('[ModelStatus] Error checking model status:', error);
      setModelStatus(prev => ({
        ...prev,
        modelAvailable: false,
        cloudFallback: false,
        source: null,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    checkModelStatus();
    const interval = setInterval(checkModelStatus, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return modelStatus;
}
